<template>
    <div class="giving-content">
        <div class="container">
            <img src="../assets/giving.svg" alt="TONE GIVING" title="TONE Giving">
            <h2>giving</h2>
            <p>
                While we can't give you back time, we can make it easier to give back to others. This is why we created Clicks For Good. The more time you spend on TONE, the more we'll donate to the charity of your choice. Thanks for helping us out!
            </p>
            <!--/////////////////////////////////////////////////////////////////////-->
            <div v-for="charity in getAllCharities" :key="charity.charityId">
                <div class="row givingVideos">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <!--<img v-bind:src="charity.img_url" alt="">-->
                        <div class="panel-body">
                            <div>
                                <div >
                                    <div class="slide-player">
                                        <img class="jw-img" :src="charity.img_url" :title="charity.name" :alt="charity.name"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <h3>{{charity.name}}<br><small><a class="weblink" target="_new" v-bind:href="charity.website">{{ charity.website }}</a></small></h3>
                        <p>
                           {{charity.description}}
                        </p>
                        <div v-if="getSelectedCharity">
                        <!--<button type="button" @click="openModal({name: 'myCharity', info: 'charity info'})">Choose this Charity</button>-->
                            <div v-if="checkCharity (charity) === true">
                                <button class="selectedCharity" type="button">Your Charity!</button>
                            </div>
                            <div v-else>
                                <!--<button type="button" @click="openModal(charity)">Choose this Charity!</button>-->
                                <button type="button" @click="changeCharity(charity)">
                                    Choose this Charity!
                                    <!--<spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>-->
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--<modal v-if="showModal" effect="zoom" :value="showModal" @cancel="cancelModal()" width="915">-->
            <!--<div slot="modal-header"></div>-->
            <!--<div slot="modal-body" class="modal-body">-->
                <!--<h4 v-if="getSelectedCharity === null">Ready to make your charity selection?</h4>-->
                <!--<h4 v-else>Ready to change your charity selection?</h4>-->
                <!--<div class="selectedImage">-->
                    <!--<img v-bind:src="currentCharity.img_url" alt="LOGO" v-bind:title="currentCharity.title">-->
                <!--</div>-->
                <!--<a class="cursor" @click="cancelModal()">No Thanks</a>-->
                <!--&lt;!&ndash;<template v-if="currentCharity === null">-->
                    <!--<button type="button" @click="changeCharity()">Yes, change my selection</button>-->
                <!--</template>-->
                <!--<template v-else>-->
                    <!--<button type="button" @click="changeCharity()">Yes, make my selection</button>-->
                <!--</template>&ndash;&gt;-->

            <!--</div>-->
            <!--<div slot="modal-footer"></div>-->
        <!--</modal>-->
        <modal v-if="showModal_player" effect="zoom" :value="showModal_player" @cancel="cancelModal_player()" width="400">
            <div slot="modal-header"></div>
            <div slot="modal-body" class="modal-body">
                <jwplayer :data="currentPlayerID">Loading the player...</jwplayer>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import {modal, spinner} from 'vue-strap'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'

    export default {
        components: {
            jwplayer,
            modal: modal,
            'jwplaylist': JwPlayList,
            'spinner': spinner
        },
        name: 'giving',
        metaInfo () {
            return {
                title: 'TONE | Giving',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Giving'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Giving'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                activeClass: false,
                showModal: false,
                currentCharity: null,
                mindbodyVideos: '',
                spinner: false,
                showModal_player: false,
                tabs: {
                    videos: true,
                    chat: false,
                    discussion: false
                }
            }
        },
        computed: {...mapGetters([
            'getAllCharities', 'getSelectedCharity', 'user', 'getMindbodyVideo'])},
        mounted: function () {
            var self = this
            // Retreive User Charity
            self.$store.dispatch('GETSELECTEDCHARITY', this.user.userId).then(() => {
                // Retreive All Charities
                self.$store.dispatch('GETALLCHARITIES').then(() => {
                    /* just for testing */
                    self.getAllCharities.map(function (obj, key) {
                        if (obj.charityId === self.getSelectedCharity.charityId) {
                            obj.selectedCharity = true
                        }
                    })
                })
                // Retreive Videos to be displayed
                this.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(() => {
                    this.mindbodyVideos = this.getMindbodyVideo
                    setTimeout(() => {
                        // this.create()
                    }, 1000)
                })
            })
        },
        methods: {
            setPlayer (playerObject) {
                this.currentPlayerID = {video: playerObject.sources[1].file, title: playerObject.title, img: playerObject.image, playerID: new Date()}
                this.showModal_player = true
            },
            active () {
                this.activeClass = true
            },
            switchTab: function (id) {
                for (let tab in this.tabs) {
                    this.tabs[tab] = id === tab
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            openModal (charity) {
                this.currentCharity = charity
                this.showModal = true
            },
            cancelModal () {
                this.showModal = false
                var self = this
                setTimeout(function () {
                    self.showModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            changeCharity (charity) {
                let self = this
                self.currentCharity = charity
                window.logEvents('Giving Page', 'click', `Selected Charity: ${charity.name}`)
                var info = [self.currentCharity.charityId, self.user.userId]
                // this.spinnerToggle()
                self.$store.dispatch('SETSELECTEDCHARITY', info).then(() => {
                    self.$store.dispatch('GETSELECTEDCHARITY', self.user.userId).then(() => {
                       // this.spinnerToggle()
                        self.currentCharity.selectedCharity = !self.currentCharity.selectedCharity
                        self.$swal({
                            title: 'Charity has been updated!',
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        let redirect = sessionStorage.getItem('updatRedirect')
                        if (redirect) {
                            self.$router.push('/profile')
                            sessionStorage.removeItem('updatRedirect')
                        }
                    })
                    // this.showModal = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    // $('.modal-open').removeClass('modal-open')
                })
            },
            checkCharity (charity) {
                return this.getSelectedCharity.charityId === charity.charityId
            },
            cancelModal_player () {
                var self = this
                var $ = window.jQuery
                setTimeout(function () {
                    self.showModal_player = false
                    /* remove the class added by default by modal, when open to retain the scrolling behaviour */
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            }
        }
    }
</script>
<style scoped>
    .weblink {
        text-transform: lowercase;
        font-size: 14px;
        line-height: 1.3;
        display:block;
        text-indent:1.5px;
    }
</style>



// WEBPACK FOOTER //
// Giving.vue?6803318e